<script>
import { ref } from "vue";
const value = ref();
const currentDate = ref(new Date());
export default {
  data() {
    return {
      startdate: currentDate,
      dateFormat: "dd-MM-yyyy",
      showFilterInputs: false,
      CustomSelec: ["Customer ID", "CU0263", "CU3695"],
      RaySelect: ["Customer", "Anthony Lewis", "Linda Ray"],
      CustomActive: ["Status", "Active", "Inative"],
    };
  },
  methods: {
    toggleFilterInputs() {
      this.showFilterInputs = !this.showFilterInputs;
    },
  },
};
</script>
<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div
            class="d-flex align-items-center justify-content-between flex-wrap row-gap-3 mb-4"
          >
            <h4>Customers</h4>
            <div class="d-flex align-items-center flex-wrap row-gap-3">
              <span class="fs-14 me-2">Sort</span>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Newly Added
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active">Ascending</a>
                  <a href="javascript:void(0);" class="dropdown-item">Descending</a>
                </div>
              </div>
              <div class="dropdown me-2">
                <a
                  href="javascript:void(0);"
                  class="dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export
                </a>
                <div class="dropdown-menu">
                  <a href="javascript:void(0);" class="dropdown-item active"
                    >Export as PDF</a
                  >
                  <a href="javascript:void(0);" class="dropdown-item">Export as Excel</a>
                </div>
              </div>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-printer"></i
              ></a>
              <a
                href="javascript:void(0);"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                id="filter_search"
                ><i class="ti ti-sort-descending"></i
              ></a>
              <router-link
                to="/provider/customer-grid"
                class="tags active d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-layout-grid"></i
              ></router-link>
              <router-link
                to="/provider/customer-list"
                class="tags d-flex justify-content-center align-items-center border rounded me-2"
                ><i class="ti ti-list"></i
              ></router-link>
              <a
                href="javascript:void(0);"
                class="btn btn-dark d-flex align-items-center"
                data-bs-toggle="modal"
                data-bs-target="#add-user"
                ><i class="ti ti-circle-plus me-2"></i>Add Customer</a
              >
            </div>
          </div>
          <div
            id="filter_inputs"
            v-bind:style="{ display: showFilterInputs ? 'block' : 'none' }"
          >
            <div class="row">
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <div class="sel-cal Calendar-icon">
                    <span><i class="ti ti-calendar-month"></i></span>
                    <date-picker
                      v-model="startdate"
                      placeholder=""
                      class="datetimepicker form-control"
                      :editable="true"
                      :clearable="false"
                      :input-format="dateFormat"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="CustomSelec"
                    id="customselc"
                    placeholder="Customer ID"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="RaySelect"
                    id="rayselect"
                    placeholder="Customer"
                  />
                </div>
              </div>
              <div class="col-lg-3 col-md-6 col-xl">
                <div class="mb-3">
                  <vue-select
                    :options="CustomActive"
                    id="customactive"
                    placeholder="Status"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-35.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Brian Villalobos</router-link>
                      </h6>
                      <span class="fs-12">brian@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2146</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">50</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">20/02/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$1800</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 03/05/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-36.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Harvey Smith</router-link>
                      </h6>
                      <span class="fs-12">harvey@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 964 648 5497</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">30</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">20/02/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$1200</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 22/06/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-52.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Stephan Peralt</router-link>
                      </h6>
                      <span class="fs-12">peral@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 654 749 6488</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">45</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">15/03/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$1700</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 14/06/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-53.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Doglas Martini</router-link>
                      </h6>
                      <span class="fs-12">martniwr@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 968 648 6964</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">25</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">12/04/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$1100</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 08/07/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-54.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Linda Ray</router-link>
                      </h6>
                      <span class="fs-12">ray456@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 315 249 3478</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">10</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">20/05/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$800</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 17/08/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-55.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Elliot Murray</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 314 987 3145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">20</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">06/07/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$1000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 14/06/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-3 col-lg-4 col-md-6">
              <div class="card">
                <div class="card-body">
                  <div class="d-flex align-items-center pb-2 border-bottom mb-3">
                    <router-link to="/provider/customer-details" class="avatar avatar-lg me-2">
                      <img
                        src="@/assets/img/profiles/avatar-02.jpg"
                        class="rounded-circle"
                        alt="Img"
                      />
                    </router-link>
                    <div>
                      <h6 class="fs-14">
                        <router-link to="/provider/customer-details">Anthony Lewis</router-link>
                      </h6>
                      <span class="fs-12">anthony@example.com</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Phone</span>
                        <h6 class="fs-12">+1 634 967 2145</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Total Bookings</span>
                        <h6 class="fs-12">60</h6>
                      </div>
                    </div>
                    <div class="col-6">
                      <div class="mb-3">
                        <span class="fs-12">Created On</span>
                        <h6 class="fs-12">14/01/2024</h6>
                      </div>
                      <div class="mb-3">
                        <span class="fs-12">Amount Received </span>
                        <h6 class="fs-12">$2000</h6>
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex justify-content-between flex-wrap row-gap-2 border-top pt-3"
                  >
                    <span class="badge badge-light text-dark">
                      Last Booking : 16/04/2024
                    </span>
                    <span class="badge badge-success-100 d-flex align-items-center"
                      ><i class="ti ti-point-filled me-1"></i>Active</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <a href="javascript:void(0);" class="btn btn-dark d-flex align-items-center"
              ><i class="ti ti-loader me-2"></i>Loading</a
            >
          </div>
        </div>
      </div>
    </div>
    <customer-grid-modal></customer-grid-modal>
  </div>
</template>
